import { RootState } from "redux/rootReducer";

export const selectIsDownloadingFullStressCsv = (state: RootState) =>
  state.fullStressCsvDownload.loading;
export const fullStressCsvDownloadErrorMessage = (state: RootState) =>
  state.fullStressCsvDownload.error;
export const fullStressCsvDownloadSuccessResponse = (state: RootState) =>
  state.fullStressCsvDownload.fullStressCsvDownloadResponse;
